import type { Control, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import type { TreatmentReportFormData } from '@/schemas/treatmentReportSchema';
import type {
  ClinicLocationOption,
  MassagerOption,
} from '@/services/main/treatmentReport';

export const TREATMENT_REPORT_LABEL_KEYS = [
  'treatment_report_date',
  'doctor_name',
  'contents_frequency',
  'treatment_monthly_avg',
  'status_course',
  'remarks',
  'massager_id',
  'location_name',
  'address',
  'telephone',
  'fax',
  'email',
] as const;

export type TreatmentReportFormMode = 'create' | 'edit';
export type TreatmentReportLabelKey = (typeof TREATMENT_REPORT_LABEL_KEYS)[number];
export type TreatmentReportLabelChecks = Record<string, boolean>;
export type TreatmentReportOption = { value: number | ''; label: string };

export interface ExistingTreatmentReport {
  id: number;
  treatment_yearmonth: number;
}

export interface TreatmentReportFormSectionProps {
  control: Control<TreatmentReportFormData>;
  watch: UseFormWatch<TreatmentReportFormData>;
  setValue: UseFormSetValue<TreatmentReportFormData>;
  formMode: TreatmentReportFormMode;
  massagers: MassagerOption[];
  disabled?: boolean;
  /** Existing treatment reports for this patient (used for duplicate/5-month check) */
  existingReports?: ExistingTreatmentReport[];
  /** Current report id (edit mode) — excluded from duplicate check */
  currentReportId?: number;
  /** Patient ID for API calls (再取得) */
  patientId?: string;
  /** Pre-seeded hospital for edit mode — avoids async flicker on initial render */
  initialHospital?: { id: number; name: string } | null;
  /** Pre-seeded massager for edit mode — keeps saved selection visible before options refetch */
  initialMassager?: { id: number; name: string | null; serial_number?: number | null } | null;
  /** Pre-seeded location for edit mode — keeps saved selection visible before options refetch */
  initialClinicLocation?: ClinicLocationOption | null;
  /** Whether we are in "copy from previous" mode (Point 1) */
  isCopying?: boolean;
  /** Active consent content, owned by the page so submit-time validation sees the latest value */
  activeConsentContent?: string | null;
  /** Notify the page when active consent content changes (after 再取得 / auto-recalc) */
  onActiveConsentChange?: (content: string | null) => void;
}

